import React from "react";
import { Card } from "@/components/ui/card";
import { Reveal, SectionTitle, Stars } from "./common";
import { TESTIMONIALS } from "@/lib/site";

const initials = (name) =>
  name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

export const Testimonials = () => {
  return (
    <section id="testimonios" data-testid="testimonials-section" className="py-14 sm:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 sm:px-6">
        <Reveal>
          <SectionTitle
            eyebrow="Familias felices"
            title="Lo que dicen otras mamás y papás"
            subtitle="Momentos reales de conexión que nacen con solo unos crayones y esta historia."
          />
        </Reveal>
        <div className="mt-10 grid grid-cols-1 gap-4 sm:gap-6 md:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.08}>
              <Card
                data-testid="testimonial-card"
                className="relative h-full overflow-hidden rounded-2xl border-[hsl(var(--border))] bg-white p-6 shadow-[0_10px_30px_rgba(31,41,55,0.08)]"
              >
                <div className="absolute -right-6 -top-6 h-16 w-16 rounded-full bg-[hsl(var(--brand-sun))]/30" />
                <Stars count={t.stars} />
                <p className="mt-4 text-sm leading-relaxed text-[hsl(var(--brand-ink))]">“{t.text}”</p>
                <div className="mt-5 flex items-center gap-3">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-[hsl(var(--brand-sky))]/40 font-heading text-sm font-bold text-[hsl(var(--brand-ink))]">
                    {initials(t.name)}
                  </span>
                  <div>
                    <p className="text-sm font-bold text-[hsl(var(--brand-ink))]">{t.name}</p>
                    <p className="text-xs text-muted-foreground">{t.role}</p>
                  </div>
                </div>
              </Card>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
